import { toFiniteSeriesNumber } from '../transforms/toFiniteSeriesNumber';
import type { TransformRow } from '../transforms/types';

/**
 * hen-ui / Recharts only draw bar and line marks when series columns are
 * finite numbers. Reporting lakes often return measures as numeric strings.
 */
export function coerceChartRowSeriesValues(
  rows: readonly TransformRow[],
  seriesKeys: readonly string[],
): TransformRow[] {
  if (seriesKeys.length === 0) {
    return [...rows];
  }
  return rows.map((row) => {
    const out = { ...row };
    for (const key of seriesKeys) {
      if (!Object.prototype.hasOwnProperty.call(out, key)) {
        continue;
      }
      out[key] = toFiniteSeriesNumber(out[key]);
    }
    return out;
  });
}
